import { useEffect, useState } from "react";
import { _QualityTraining, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectLabour } from "../../ManufacturingStandars/Labour/SelectLabour";
import { ProductionRouteSelect } from "../../ProductionRoute/ProductionRouteSelect";
import usePaginator from "../../../theme/Component/usePaginator";


interface Props {
    isModal?: boolean;
    onChange?: Function;
}

export const QualityTraining = ({ isModal, onChange }: Props) => {

    const { lista, setLista, bean, setBean, instance } = useDataBean(_QualityTraining);
    const paginator = usePaginator();

    const modal = useModal("", MODAL_LG);
    const modalC = useModal("Eliminar Inspección", MODAL_SM);

    const head = [
        { title: 'ID', property: 'IDQualityTraining', visible: true },
        { title: 'Hora de Inicio', property: 'HoraIncio', visible: true },
        { title: 'Hora Fin', property: 'HoraFin', visible: true },
        { title: 'Ruteo', property: 'ProductionRouteDescription', visible: true },
        { title: 'Labor', property: 'LabourName', visible: true },
        { title: 'Nombre de la Capacitación', property: 'Name', visible: true },
        { title: 'Operario', property: 'OperatorFullName', visible: true },
        { title: 'Usuario Capacitador', property: 'EmployeeFullName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ];

    useEffect(() => {
        getLista()
    }, [paginator.page])

    const getLista = () => {
        const Props = {
            State: 1,
        }
        instance.getQualityTrainingRender(paginator.page, 15, Props).then(
            (resp) => {
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * 15);
                resp.List.forEach(element => {
                    const pad = (num: number) => num.toString().padStart(2, '0');

                    const d = element.DataBeanProperties;
                    d.HoraIncio = `${d.FromHour ? `${pad(d.FromHour ?? 0)}:${pad(d.FromMinutes ?? 0)}` : "N/P"}`;
                    d.HoraFin = `${d.UptoHour ? `${pad(d.UptoHour ?? 0)}:${pad(d.UptoMinutes ?? 0)}` : "N/P"}`;

                });
                setLista(resp.List)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        modal.open("Agregar Capacitación");
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open("Editar Capacitación") } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const editaItem = (obj: any) => {
        instance.updateQualityTraining(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const validateForm = () => {
        const requiredFields = [
            "IDAccountOperator", "Name", "FromHour", "UptoHour", "FromMinutes", "UptoMinutes"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    const setRowBean = (obj) => {
        setBean(obj)
        if (onChange) {
            onChange(obj)
        }
    }

    const deleteItem = () => {
        let x = { ...bean, State: 2 };
        editaItem(x);
    };

    const rowContent = (
        <div className="row">
            <div className="col-md-12">
                <BasicTable
                    pageTop={paginator.page}
                    next={paginator.next}
                    back={paginator.back}
                    records={paginator}
                    listButtons={listaBotones()}
                    head={head} 
                    body={lista}
                    rowSet={setRowBean}
                    iconButtons={iconButtonsItem}
                />
            </div>
        </div>
    );

    return isModal ? rowContent : (
        <BasicPage titulo="Capacitaciones de Procesos">
            {rowContent}

            <div className="col-md-12">
                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }} >
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDAccountOperator') ? 'has-error' : ''}`} >Operario</label>
                            <AccountEditor idAccount={bean.IDAccountOperator} label=" " onChange={(e) => { setBean({ ...bean, IDAccountOperator: e.IDAccount }) }} />
                        </div>

                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`} >Nombre de la Capacitación</label>
                            <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                        </div>

                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`} >Ruteo</label>
                            <ProductionRouteSelect idSelector={bean.IDProductionRoute} onChange={(e) => { setBean({ ...bean, IDProductionRoute: e }) }} label=" " />
                        </div>

                        <div className="col-md-6">
                            <label className={`${missingFields.includes('Name') ? 'has-error' : ''}`} >Labor</label>
                            <SelectLabour IDProductionRoute={bean.IDProductionRoute} idSelector={bean.IDLabour} onChange={(e) => { setBean({ ...bean, IDLabour: e }) }} label=" " />
                        </div>

                        <div className="col-md-6">
                            <label className={`${missingFields.includes('FromHour') ? 'has-error' : ''} ${missingFields.includes('FromMinutes') ? 'has-error' : ''} `} >Hora de Inicio de la Capacitación</label>
                            <div className="row">
                                <div className="col-md-6">
                                    <select
                                        className="form-control"
                                        value={bean.FromHour ?? ""}
                                        onChange={(e) => setBean({ ...bean, FromHour: parseInt(e.target.value) })}
                                    >
                                        <option value="">HH</option>
                                        {[...Array(24)].map((_, i) => (
                                            <option key={i} value={i}>{i.toString().padStart(2, '0')}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <select
                                        className="form-control"
                                        value={bean.FromMinutes ?? ""}
                                        onChange={(e) => setBean({ ...bean, FromMinutes: parseInt(e.target.value) })}
                                    >
                                        <option value="">MM</option>
                                        {[...Array(12)].map((_, i) => (
                                            <option key={i * 5} value={i * 5}>{(i * 5).toString().padStart(2, '0')}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('UptoHour') ? 'has-error' : ''} ${missingFields.includes('UptoMinutes') ? 'has-error' : ''} `} >Hora de Finalización de la Capacitación</label>
                            <div className="row">
                                <div className="col-md-6">
                                    <select
                                        className="form-control"
                                        value={bean.UptoHour ?? ""}
                                        onChange={(e) => setBean({ ...bean, UptoHour: parseInt(e.target.value) })}
                                    >
                                        <option value="">HH</option>
                                        {[...Array(24)].map((_, i) => (
                                            <option key={i} value={i}>{i.toString().padStart(2, '0')}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <select
                                        className="form-control"
                                        value={bean.UptoMinutes ?? ""}
                                        onChange={(e) => setBean({ ...bean, UptoMinutes: parseInt(e.target.value) })}
                                    >
                                        <option value="">MM</option>
                                        {[...Array(12)].map((_, i) => (
                                            <option key={i * 5} value={i * 5}>{(i * 5).toString().padStart(2, '0')}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <label className={`${missingFields.includes('Description') ? 'has-error' : ''}`} >Descripción de la Capacitación</label>
                            <textarea value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} className="form-control" />
                        </div>



                    </div>
                </Modal>

                <ModalConfirm eventModal={() => { deleteItem() }} updateModal={modalC.setModal} modal={modalC.modal} >
                    <strong>¿Desea Continuar con la accion?</strong>
                </ModalConfirm>
            </div>
        </BasicPage>
    );
}



